import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import api from '../../services/api';
import { FiUser, FiCreditCard } from 'react-icons/fi';

const SettingsPage = () => {
  const { user, business } = useAuth();
  const { showToast } = useToast();

  const [plan, setPlan] = useState(business?.plan || 'FREE');
  const [updatingPlan, setUpdatingPlan] = useState(false);

  const handleUpdatePlan = async (selectedPlan) => {
    setUpdatingPlan(true);
    try {
      const res = await api.put('/business', { plan: selectedPlan });
      if (res.success) {
        setPlan(selectedPlan);
        showToast(`Plan updated to ${selectedPlan}!`, 'success');
      }
    } catch (err) {
      showToast(err.message || 'Failed to update plan', 'error');
    } finally {
      setUpdatingPlan(false);
    }
  };

  return (
    <div style={{ maxWidth: '800px' }}>
      <div style={{ marginBottom: '1.5rem' }}>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.75rem', fontWeight: 800 }}>
          Account & Plan Settings
        </h1>
        <p style={{ color: '#94A3B8', fontSize: '0.95rem' }}>
          Manage your account profile and subscription plan.
        </p>
      </div>

      <div className="glass-card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.15rem', fontWeight: 700, marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FiUser style={{ color: 'var(--primary-500)' }} /> Account Profile
        </h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="form-group">
            <label className="form-label">Full Name</label>
            <input type="text" className="form-control" disabled value={user?.name || ''} />
          </div>

          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input type="email" className="form-control" disabled value={user?.email || ''} />
          </div>
        </div>
      </div>

      <div className="glass-card">
        <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.15rem', fontWeight: 700, marginBottom: '1.25rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FiCreditCard style={{ color: 'var(--primary-500)' }} /> Subscription Plan
        </h3>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem' }}>
          <div
            style={{
              padding: '1.5rem',
              borderRadius: '16px',
              background: '#1E293B',
              border: plan === 'FREE' ? '2px solid var(--primary-500)' : '1px solid rgba(255,255,255,0.08)'
            }}
          >
            <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#fff' }}>FREE Plan</h4>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', margin: '0.5rem 0', color: 'var(--primary-500)' }}>₹0</div>
            <ul style={{ fontSize: '0.85rem', color: '#94A3B8', paddingLeft: '1.2rem', margin: '1rem 0' }}>
              <li>5 Products Max</li>
              <li>Minimal White Theme</li>
              <li>Basic QR Code</li>
            </ul>
            <button
              onClick={() => handleUpdatePlan('FREE')}
              disabled={plan === 'FREE' || updatingPlan}
              className={`btn ${plan === 'FREE' ? 'btn-secondary' : 'btn-outline'} btn-sm`}
              style={{ width: '100%' }}
            >
              {plan === 'FREE' ? 'Current Plan' : 'Switch to Free'}
            </button>
          </div>

          <div
            style={{
              padding: '1.5rem',
              borderRadius: '16px',
              background: '#1E293B',
              border: plan === 'BASIC' ? '2px solid var(--primary-500)' : '1px solid rgba(255,255,255,0.08)'
            }}
          >
            <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#fff' }}>BASIC Plan</h4>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', margin: '0.5rem 0', color: 'var(--primary-500)' }}>₹499/yr</div>
            <ul style={{ fontSize: '0.85rem', color: '#94A3B8', paddingLeft: '1.2rem', margin: '1rem 0' }}>
              <li>Unlimited Products</li>
              <li>All 5 Themes</li>
              <li>Digital Visiting Card</li>
            </ul>
            <button
              onClick={() => handleUpdatePlan('BASIC')}
              disabled={plan === 'BASIC' || updatingPlan}
              className={`btn ${plan === 'BASIC' ? 'btn-secondary' : 'btn-primary'} btn-sm`}
              style={{ width: '100%' }}
            >
              {plan === 'BASIC' ? 'Current Plan' : 'Select Basic Plan'}
            </button>
          </div>

          <div
            style={{
              padding: '1.5rem',
              borderRadius: '16px',
              background: '#1E293B',
              border: plan === 'PRO' ? '2px solid var(--primary-500)' : '1px solid rgba(255,255,255,0.08)'
            }}
          >
            <h4 style={{ fontSize: '1.1rem', fontWeight: '700', color: '#fff' }}>PRO Plan</h4>
            <div style={{ fontSize: '1.5rem', fontWeight: '800', margin: '0.5rem 0', color: 'var(--primary-500)' }}>₹999/yr</div>
            <ul style={{ fontSize: '0.85rem', color: '#94A3B8', paddingLeft: '1.2rem', margin: '1rem 0' }}>
              <li>Everything in Basic</li>
              <li>Custom Slug URL</li>
              <li>Analytics Dashboard</li>
            </ul>
            <button
              onClick={() => handleUpdatePlan('PRO')}
              disabled={plan === 'PRO' || updatingPlan}
              className={`btn ${plan === 'PRO' ? 'btn-secondary' : 'btn-primary'} btn-sm`}
              style={{ width: '100%' }}
            >
              {plan === 'PRO' ? 'Current Plan' : 'Upgrade to Pro'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
